'use client';

import React from 'react';

interface SkipToMainContentProps {
  target?: string;
}

export default function SkipToMainContent({ target = 'main' }: SkipToMainContentProps): React.ReactNode {
  const handleClick = (): void => {
    const targetNode = document.querySelector(target);

    // Sets the focus to the target element if it exists
    if (targetNode && targetNode instanceof HTMLElement) {
      targetNode.scrollIntoView();
      targetNode.setAttribute('tabindex', '-1');
      targetNode.focus();
      targetNode.addEventListener(
        'blur',
        () => {
          targetNode.removeAttribute('tabindex');
        },
        { once: true },
      );
    }
  };

  return (
    <button
      onClick={handleClick}
      className="absolute -top-96 left-2 z-[100] rounded bg-blue-600 p-2 text-white shadow-lg transition-all duration-200 focus:left-4 focus:top-4"
    >
      Skip to main content
    </button>
  );
}
